// Open modal listener
const openModalListener = event => {
  event.preventDefault();
  // Open the modal
  const modal = document.querySelector('#try-with-nok-modal');
  modal.classList.add('try-with-nok__modal--open');
  // Block body scroll while modal is open
  const bodyElement = document.querySelector('body');
  bodyElement.classList.add('try-with-nok__modal--open');

  // Elements with close listeners
  const backdrop = document.querySelector('#try-with-nok-modal--backdrop');
  const closeButton = document.querySelector('#try-with-nok-modal-close');

  // Close modal listener
  const closeModal = e => {
    e.preventDefault();
    // Close the modal
    modal.classList.remove('try-with-nok__modal--open');
    // Enable body scroll
    bodyElement.classList.remove('try-with-nok__modal--open');
    // Remove close listeners
    backdrop.removeEventListener('click', closeModal);
    closeButton.removeEventListener('clicl', closeModal);
  }


  // Add close listeners to close button and backdrop
  backdrop.addEventListener('click', closeModal);
  closeButton.addEventListener('click', closeModal);
}

(function() {
  // All buttons that should open the modal
  const tryWithNokHIWButtons = document.querySelectorAll('.try-with-nok-hiw');
  
  tryWithNokHIWButtons.forEach(button => button.addEventListener('click', openModalListener));
})()